import 'whatwg-fetch';
import './es6.nodelist.foreach';
import './node.classList';
